function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnswer1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 122 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.998,101.205c-23.259,23.914 -61.024,24.963 -84.283,2.342c-23.258,-22.622 -23.258,-60.402 0,-84.316c23.259,-23.913 61.024,-24.963 84.283,-2.341c23.258,22.621 23.258,60.402 -0,84.315Z",
    style: {
      fill: "#f7ab1e"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.713,60.857l-4.249,-0c-0.001,15.638 -6.333,29.776 -16.58,40.027c-10.251,10.247 -24.389,16.578 -40.027,16.579c-15.639,-0.001 -29.777,-6.332 -40.027,-16.579c-10.247,-10.251 -16.579,-24.389 -16.58,-40.027c0.001,-15.638 6.333,-29.777 16.58,-40.027c10.25,-10.247 24.388,-16.579 40.027,-16.58c15.638,0.001 29.776,6.333 40.027,16.58c10.247,10.25 16.579,24.388 16.58,40.027l4.249,-0c-0.001,-33.611 -27.245,-60.855 -60.856,-60.857c-33.611,0.002 -60.855,27.246 -60.857,60.857c0.002,33.611 27.246,60.855 60.857,60.856c33.611,-0.001 60.855,-27.245 60.856,-60.856Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2,47.187c-0,-2.865 2.322,-5.188 5.188,-5.188c2.864,0 5.187,2.323 5.187,5.188c-0,2.865 -2.323,5.188 -5.187,5.188c-2.866,0 -5.188,-2.323 -5.188,-5.188Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.139,47.187c0,-2.865 2.323,-5.188 5.188,-5.188c2.865,0 5.188,2.323 5.188,5.188c-0,2.865 -2.323,5.188 -5.188,5.188c-2.865,0 -5.188,-2.323 -5.188,-5.188Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.359,85.736c2.217,-5.115 5.878,-9.468 10.465,-12.538c4.589,-3.07 10.092,-4.857 16.033,-4.858c5.939,0.001 11.442,1.788 16.03,4.856c4.587,3.069 8.247,7.42 10.465,12.533c0.467,1.077 1.718,1.571 2.795,1.104c1.077,-0.467 1.571,-1.718 1.104,-2.795c-2.548,-5.872 -6.741,-10.855 -12.001,-14.374c-5.258,-3.52 -11.595,-5.575 -18.393,-5.574c-6.8,-0.001 -13.138,2.055 -18.397,5.576c-5.26,3.521 -9.454,8.506 -12,14.379c-0.467,1.077 0.027,2.328 1.104,2.795c1.077,0.467 2.328,-0.027 2.795,-1.104Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnswer1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/answer-1.035e4d7c637fe9951345698c45112334.svg";